import { useRouter } from 'next/router'
import { useEffect, useContext } from 'react'
import { useAuth } from '.'
import SplashScreen from '../../components/SplashScreen'
import { t } from '../i18n'
import { ModalsContext } from '../modals'
import { isLabEnabled } from '../isDevUser'
import { labSignInPath } from '../routeHelpers'
import guidelinesModalStyles from '../../components/modals/_guidelinesModal.module.scss'

export const ProtectRoute = (Component: React.FC, params = null) => {
  return (props) => {
    const { isAuthenticated, isLoading, isMusician, currentUser } = useAuth()
    const router = useRouter()
    const isForbidden = params?.protectFromMusician && isMusician
    const inDevelopment = params?.inDevelopment
    const isLabPage = params?.isLabPage
    const isCommunityPage = params?.isCommunityPage
    const hasLabSubscription = currentUser?.labSubscriptionActive
    const isGuidelinesAccepted = !!currentUser?.guidelinesAcceptedAt

    const { openModal, closeModal } = useContext(ModalsContext)

    const openSignInModal = () => {
      openModal({
        name: 'SignIn',
        props: {
          onClose: closeModal
        },
        onModalClose: onClose,
        modalTitle: t('Sign In')
      })
    }
    const onClose = () => {
      router.back()
    }

    const openLabSignInModal = () => {
      router.push(labSignInPath())
    }

    const openGuidelinesModal = () => {
      openModal({
        name: 'GuidelinesModal',
        props: {
          onClose: closeModal
        },
        onModalClose: () => {},
        modalTitle: '',
        hideCloseButton: true,
        modifier: guidelinesModalStyles.guidelinesModalModifier
      })
    }

    useEffect(() => {
      if (!isLoading) {
        if (isLabPage && !(hasLabSubscription && isLabEnabled(currentUser))) {
          openLabSignInModal()
        } else if (
          isCommunityPage &&
          hasLabSubscription &&
          !isGuidelinesAccepted
        ) {
          openGuidelinesModal()
        } else if (isForbidden || (!isAuthenticated && !isCommunityPage)) {
          openSignInModal()
        }
      }
    }, [
      isLoading,
      isAuthenticated,
      isMusician,
      isLabPage,
      hasLabSubscription,
      isCommunityPage,
      isGuidelinesAccepted
    ])

    if (!isCommunityPage && (isLoading || !isAuthenticated)) {
      return <SplashScreen />
    }

    if (inDevelopment && isAuthenticated && !isLabEnabled(currentUser)) return

    return <Component {...props} />
  }
}
